export default class ChargebackHistoryController {
  constructor(resource) {
    this._resource = resource;
  }

  async findByFilters(filters) {
    try {
      let response = await this._resource(
        `chargeback-history-filters/${filters}`
      ).get({ filters });
      return response.body;
    } catch (error) {
      throw error;
    }
  }
}
